module.exports = __webpack_public_path__ + "img/设备智联数字化分析平台.cbe8e115.png";